import React, { Component } from 'react';

import { bemClasses } from '../../utils/bem';

import './styles.scss';

import { Row } from 'reactstrap';

import ButtonGroup from '../buttonGroup';
import Column from '../column';
import InputWithButton from '../form/inputWithButton';
import PageHeaderTitle from './pageHeaderTitle';
import Text from '../text';
import Wrapper from '../wrapper';

class PageHeader extends Component {
  ALLOWED_MODIFIERS = ['white', 'fullWidth', 'centered'];

  componentClassNames = () => {
    return bemClasses('page-header', this.ALLOWED_MODIFIERS, this.props);
  };

  buttons = () => {
    if (!this.props.buttons) {
      return;
    }

    return (
      <ButtonGroup
        buttons={this.props.buttons}
        unjoined={this.props.unjoinedButtons}
        hidden={{ xs: true, sm: true, md: true }}
      />
    );
  };

  renderAdditionalButtons = () => {
    if (this.shouldRenderAdditionalButtons()) {
      return (
        <Column xs={12} lg={{ size: 8, offset: this.props.centered ? 3 : 0 }}>
          <Wrapper end>{this.buttons()}</Wrapper>
        </Column>
      );
    }
  };

  renderDescription = () => {
    if (!this.props.description) {
      return;
    }

    return (
      <Column xs={12}>
        <Text lightGrey>{this.props.description}</Text>
      </Column>
    );
  };

  renderSearchBox = () => {
    if (!this.props.onSearch) {
      return;
    }

    return (
      <Column xs={12}>
        <InputWithButton
          onSubmit={this.props.onSearch}
          placeholder={'Search'}
          value={this.props.searchTerm}
          fullWidth
          white
        />
      </Column>
    );
  };

  render = () => {
    return (
      <Row className={this.componentClassNames()}>
        <PageHeaderTitle
          centered={this.props.centered}
          title={this.props.title}
          light={this.props.light}
          white={this.props.white}
          large={this.props.large}
          fullWidth={!this.shouldRenderAdditionalButtons()}
          mobileDropdownOptions={this.props.buttons}
        />

        {this.renderAdditionalButtons()}

        {this.renderDescription()}

        {this.renderSearchBox()}
      </Row>
    );
  };

  shouldRenderAdditionalButtons = () => {
    return this.props.buttons || this.props.onSearch;
  };
}

export default PageHeader;
